import React from 'react'
import { Container, FieldText, TextTitle } from '@pmi/pmi-iqos-ds-react'

const Comment = ({ initialProps, comment, setComment, validationValues }) => {
  return (
    <Container
      py="6"
      px="4"
      borderColor={Container.borderColors.primary}
      fullWidth
      fullHeight
      display={Container.displays.flex}
      flexDirection={Container.flexDirections.column}>
      <Container pb="1">
        <TextTitle heading={TextTitle.headings.h6}>
          {initialProps.heading}
        </TextTitle>
      </Container>
      <FieldText
        fullWidth={true}
        paragraph
        label={initialProps.label}
        value={comment || ''}
        name={initialProps.label}
        onChangeHandler={e => setComment(e, initialProps.id)}
        errors={validationValues}
        errorIconAlignment={FieldText.errorIconAlignments.start}
      />
    </Container>
  )
}

export default Comment
